import {
    configureStore
} from '@reduxjs/toolkit'
import emergingDragonReducer from './emerging-dragon'

export default configureStore({
    reducer: {
        emergingDragon: emergingDragonReducer
    }
})